import { api } from '@/api'
import type { Customer, CustomersResponse } from '../types'

// GET /bff/customers?query=&offset=&limit= → { customers }. Page params match
// the mobile client (offset 0, limit 10); the screen drives only `query`.
export function findCustomers(query: string): Promise<Customer[]> {
  return api
    .get<CustomersResponse>('/customers', { params: { query, offset: 0, limit: 10 } })
    .then((data) => data.customers)
}
